import { Box, BoxProps } from "@chakra-ui/react";

export function CompletedIcon({
  color = "currentColor",
  ...props
}: BoxProps & { color?: string }) {
  return (
    <Box position="relative" {...props}>
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.602 14.175L8.45195 12.025C8.26862 11.8417 8.03529 11.75 7.75195 11.75C7.46862 11.75 7.23529 11.8417 7.05195 12.025C6.86862 12.2083 6.77695 12.4417 6.77695 12.725C6.77695 13.0083 6.86862 13.2417 7.05195 13.425L9.90195 16.275C10.102 16.475 10.3353 16.575 10.602 16.575C10.8686 16.575 11.102 16.475 11.302 16.275L16.952 10.625C17.1353 10.4417 17.227 10.2083 17.227 9.925C17.227 9.64167 17.1353 9.40833 16.952 9.225C16.7686 9.04167 16.5353 8.95 16.252 8.95C15.9686 8.95 15.7353 9.04167 15.552 9.225L10.602 14.175ZM12.002 22.375C10.6186 22.375 9.31862 22.1125 8.10195 21.5875C6.88529 21.0625 5.82695 20.35 4.92695 19.45C4.02695 18.55 3.31445 17.4917 2.78945 16.275C2.26445 15.0583 2.00195 13.7583 2.00195 12.375C2.00195 10.9917 2.26445 9.69167 2.78945 8.475C3.31445 7.25833 4.02695 6.2 4.92695 5.3C5.82695 4.4 6.88529 3.6875 8.10195 3.1625C9.31862 2.6375 10.6186 2.375 12.002 2.375C13.3853 2.375 14.6853 2.6375 15.902 3.1625C17.1186 3.6875 18.177 4.4 19.077 5.3C19.977 6.2 20.6895 7.25833 21.2145 8.475C21.7395 9.69167 22.002 10.9917 22.002 12.375C22.002 13.7583 21.7395 15.0583 21.2145 16.275C20.6895 17.4917 19.977 18.55 19.077 19.45C18.177 20.35 17.1186 21.0625 15.902 21.5875C14.6853 22.1125 13.3853 22.375 12.002 22.375Z"
          fill="#00A177"
        />
      </svg>
    </Box>
  );
}
